module.exports = __webpack_public_path__ + "img/Porto Apartment - 4 of 85.c884d284.jpeg";